export default __webpack_public_path__ + "static/2-4bb81e756ac49f7758b070bf8270f447.jpg";